/** @format */

import React from "react";
import "../Style/Footer.css";
const Footer = () => {
  return (
    <div className="footer">
      <p>
        {" "}
        <a href="https://github.com/atefehmohammaddoust/weather-react">
          Open-source code
        </a>
        , by{" "}
        <a href="mailto:Atefeh.mohammaddoust@gmail.com">Atefeh Mohammaddoust</a>{" "}
        from
        <a href="https://www.shecodes.io/demos/react"> She Codes</a>
      </p>
    </div>
  );
};
export default Footer;
